"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpriteAtlas = void 0;
/** Pack immutable sprites into shared textures. Live regions are never overwritten. */
class SpriteAtlas {
    pageSize;
    page = null;
    x = 0;
    y = 0;
    rowHeight = 0;
    constructor(pageSize = 1024) {
        this.pageSize = pageSize;
    }
    allocate(width, height) {
        if (width > this.pageSize || height > this.pageSize || width <= 0 || height <= 0) {
            throw new Error('Sprite dimensions exceed atlas page size');
        }
        if (this.x + width > this.pageSize) {
            this.x = 0;
            this.y += this.rowHeight;
            this.rowHeight = 0;
        }
        if (!this.page || this.y + height > this.pageSize) {
            this.page = document.createElement('canvas');
            this.page.width = this.pageSize;
            this.page.height = this.pageSize;
            this.x = 0;
            this.y = 0;
            this.rowHeight = 0;
        }
        const region = { canvas: this.page, x: this.x, y: this.y, width, height };
        this.x += width;
        this.rowHeight = Math.max(this.rowHeight, height);
        return region;
    }
}
exports.SpriteAtlas = SpriteAtlas;
//# sourceMappingURL=spriteAtlas.js.map